import { Volume2, Loader2 } from 'lucide-react';

interface QuestionDisplayProps {
  questionText: string;
  category: string;
  onPlayAudio: () => void;
  isAudioPlaying: boolean;
  isAudioLoading: boolean;
}

export default function QuestionDisplay({
  questionText,
  category,
  onPlayAudio,
  isAudioPlaying,
  isAudioLoading,
}: QuestionDisplayProps) {
  return (
    <div className="flex flex-col items-center text-center">
      <span className="inline-block font-sans text-xs font-semibold uppercase tracking-[0.2em] bg-primary-light text-primary px-3 py-1 rounded-full mb-5 md:mb-6">
        {category}
      </span>
      <h2 className="font-display font-semibold text-2xl md:text-3xl lg:text-4xl text-text-primary leading-[1.2] mb-5 md:mb-6 max-w-2xl">
        {questionText}
      </h2>
      <button
        onClick={onPlayAudio}
        disabled={isAudioPlaying || isAudioLoading}
        className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-border bg-card/60 hover:bg-card font-sans text-sm font-medium text-primary hover:text-primary-dark disabled:opacity-50 disabled:cursor-not-allowed transition-colors cursor-pointer"
      >
        {isAudioLoading ? (
          <Loader2 size={16} className="animate-spin" />
        ) : (
          <Volume2 size={16} />
        )}
        {isAudioPlaying ? 'Playing…' : isAudioLoading ? 'Loading…' : 'Play question'}
      </button>
    </div>
  );
}
